import React, { useState } from "react"

import sendVerificationEmail from "../../bssr-api/auth0/send-verification-email"

function EmailNotice({ user }) {
  const [resendMessage, setResendMessage] = useState(null)
  const { user_id } = user

  // Trigger verification email call
  const triggerVerificationEmail = async () => {
    const res = await sendVerificationEmail({ user_id })
    if (res.data.message.includes("successful")) {
      setResendMessage(
        "Your verification link was resent successfully. Please check your emails and click on the link to verify your email address."
      )
    }
  }

  return (
    <div className="bg-yellow-300 py-6 px-4">
      <div className="container mx-auto px-3 leading-tight">
        <h4 className="text-lg font-semibold mb-2">
          A verification link has been sent to your email account
        </h4>
        <div>
          {user.email &&
            (resendMessage ? (
              <p className="black m-0 mb-1">{resendMessage}</p>
            ) : (
              <>
                <p className="black mb-1">
                  We have sent a verification link to{" "}
                  <span className="font-bold">{user.email}</span>. Please check
                  your emails and click on the link to verify your email
                  address.
                </p>
                <p className="black m-0">
                  If you can't find the email then{" "}
                  <span
                    className="font-bold underline"
                    role="button"
                    tabIndex="0"
                    onClick={triggerVerificationEmail}
                    onKeyDown={(e) =>
                      e.key === "Enter" && triggerVerificationEmail
                    }
                  >
                    click here
                  </span>{" "}
                  and we'll resend it to you.
                </p>
              </>
            ))}
        </div>
      </div>
    </div>
  )
}

export default EmailNotice
